import React from "react";
import EditOutlined from "@mui/icons-material/EditOutlined";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { startScreenNavigation } from "@telemetry/navigationTiming";
import { paths } from "@utils/navigation";
import { useNavigate } from "react-router-dom";

const RENEWABLE_STATUSES = new Set(["APPROVED", "EXPIRED"]);

interface RequestVendorLicenseRenewalProps {
  licenseId: string;
  companyId?: string | null;
  status?: string;
  isPortOperatorLicense?: boolean;
  isVendorMasterContext?: boolean;
}

const RequestVendorLicenseRenewal: React.FC<RequestVendorLicenseRenewalProps> = ({
  licenseId,
  companyId,
  status,
  isPortOperatorLicense = false,
  isVendorMasterContext = false,
}) => {
  const navigate = useNavigate();
  const userCompanyId = useAuthStore((state) => state.user?.companyId ?? null);
  const isSameCompany = Boolean(companyId && userCompanyId && companyId === userCompanyId);

  if (!isVendorMasterContext || isPortOperatorLicense || !isSameCompany) return null;

  return (
    <FlowActionButton
      langBase="licensing"
      isActionAvailable={Boolean(status && RENEWABLE_STATUSES.has(status))}
      labelKey="update-license-details"
      testId="update-vendor-license-details"
      variant="outlined"
      startIcon={<EditOutlined />}
      onClick={() => {
        startScreenNavigation("Licenses", window.location.pathname, "MarHub Access Renewal");
        navigate(
          `/${paths.licenses.index}/${paths.licenses.vendorLicenseRenewal.replace(":renewalId", licenseId)}`,
        );
      }}
    />
  );
};

export default RequestVendorLicenseRenewal;
